'use strict';

const saPreventAutoscroll = [
  '$window',
  'scrollTop',

  function ($window, scrollTop) {
    return {
      restrict: 'A',
      link: function () {
        $window.addEventListener('beforeunload', function () {
          scrollTop(0);
        });
      }
    };
  }
];

export default saPreventAutoscroll;



// WEBPACK FOOTER //
// ./app/src/directives/prevent_autoscroll.js